/** biome-ignore-all lint/a11y/noStaticElementInteractions: TODO: @VadymMatok fix this */
/** biome-ignore-all lint/a11y/noNoninteractiveTabindex: TODO: @VadymMatok fix this */
/** biome-ignore-all lint/a11y/useKeyWithClickEvents: TODO: @VadymMatok fix this */
import clsx from 'clsx';

import type {GuideCardProps} from '@/types/content';
import {TIPS_CARD_SIZES} from '@/types/content';

import BigCardContent from './BigCardContent';
import SmallCardContent from './SmallCardContent';

const TipsCard = ({
    title,
    imageMedia,
    size = TIPS_CARD_SIZES.SMALL,
    borderless = false,
    className,
    onClick,
}: GuideCardProps) => {
    const isBigBorderless = size === TIPS_CARD_SIZES.BIG && borderless;
    const isBig = size === TIPS_CARD_SIZES.BIG;

    return (
        <div
            onClick={onClick}
            tabIndex={0}
            className={clsx(
                'flex cursor-pointer flex-col overflow-hidden rounded-2xl bg-tips-card-surface text-left',
                !isBig && 'px-4 pt-4 pb-4',
                className
            )}
        >
            {isBig ? (
                <BigCardContent title={title} imageMedia={imageMedia} isBigBorderless={isBigBorderless} />
            ) : (
                <SmallCardContent title={title} imageMedia={imageMedia} borderless={borderless} />
            )}
        </div>
    );
};

export default TipsCard;
